export const getDelegateTeamsState = state => state.delegateTeams;
export const getDelegateTeams = state => getDelegateTeamsState(state).data;
